import React, { useState } from "react";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar.js";
import "./CommonContainerStyles.css";
import "../Home/Home.css";
import Tabs from "../../Components/Tabs/Tabs";
import CollegeLogo from "../../Components/UserAvatar/CollegeLogoHome";
// import { Link } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import ViewBar from "../../Components/ViewBar/ViewBarCollege.js";
import PopUp from "../../Components/PopUpForm/ShareProfile-College";
import "./HomeContainer2.css";
import FormField from "../../Components/FormField/FormField";
import { Fragment } from "react";
import ReactTooltip from "react-tooltip";
import StickyButton from "../../Components/Buttons/StickyButton.js";
import { isURL } from "validator"

function CollegeHomeContainer(props) {
  const {
    tabs,
    tabProfileActive,
    isShared,
    user,
    institution,
    uploadAvatar,
    isAbleToEdit,
    isShowUploadAvatar,
    isViewAsTeacher,
    isViewAsCollege,
    isSeparateTabsWithLogo,
    isSkipInnerSpacing,
    hideViewBar,
    updateTagline,
    updateWebsiteURL,
    viewbookings,
    removeTopMargin,
    showShareButton
  } = props;

  // console.log("INSTITUTE",institution);
  const [tagline, setTagline] = useState(institution.tagline);
  const [viewEditTagline, setEditTagline] = useState(false);
  const [websiteURL, setWebsiteURL] = useState(institution.website_url);
  const [viewEditWebsite, setEditWebsite] = useState(false);
  const [formType, setFormType] = useState("");
  const [isPopup, togglePopup] = useState(false);

  const handleEditTagline = () => {
    if (tagline !== institution.tagline) {
      updateTagline(tagline);
    }
    setEditTagline(false);
  };

  const handleEditWebsiteURL = () => {
    if (!websiteURL || websiteURL === "https://www.") {
      updateWebsiteURL("");
    } else if (!isURL(websiteURL)) {
      setWebsiteURL(institution.website_url);
    } else if (websiteURL !== institution.website_url) {
      updateWebsiteURL(websiteURL);
    }
    setEditWebsite(false);
  };

  /* check to see if its college or personnel - lieh */
  const menuLogoBar =
    !user || !user.hasOwnProperty("personnel_email") ? (
      isViewAsTeacher ? (
        <SwitchMenuBar isViewAsTeacher />
      ) : (
        <SwitchMenuBar
          isViewAsCollege={isViewAsCollege}
          viewbookings={viewbookings}
        />
      )
    ) : (
      <SwitchMenuBar isViewAsPersonnel={true} viewbookings={viewbookings} />
    );

  // const handleTaglineUpdateByKey = (e) => {
  //   if (e.key === 'Enter' || e.keyCode === 13) {
  //     updateTagline(tagline)
  //     setEditTagline(false)
  //   }
  // }

  const showShareProfile = () => {
    // console.log("run function share");

    setFormType("shareProfile");
    togglePopup(true);
  };

  return (
    <div className="page-container-outer">
      <div className="menu-logo-bar">
        {!isShared && !hideViewBar && (
          <ViewBar
            isViewAsCollege={isViewAsCollege}
            tabProfileActive={tabProfileActive}
            collegeID={institution._id}
          />
        )}
        {/* replace html with jsx for checking if its personnel or customer - lieh */}
        {menuLogoBar}
      </div>
      <div className="page-container-main bg-photoregister">
        <div className="bg-gradient page-container-bg"/>
        <div className="page-container-header">
          {/* header contents like teacher avatar, name/location, share button will go in here  */}
          <div className="page-container-header-inner">
            <div className="home-container-college-info">
              {/*<CollegeLogo icon={institution.logo}>*/}
              <CollegeLogo icon={institution.logo}>
                {isShowUploadAvatar && isAbleToEdit ? (
                  <span
                    className="mdi mdi-camera college-upload-avatar-button"
                    onClick={uploadAvatar}
                  />
                ) : null}
              </CollegeLogo>
              <div className="home-college-name pb-16">
                <div className="d-flex">
                  <h1>
                    {/* {user.first_name+" "+user.last_name} */}
                    {institution.institution_name}
                  </h1>
                  <div className="ml-3 mb-2 d-flex align-items-start">
                    {viewEditWebsite ? (
                      <form onSubmit={handleEditWebsiteURL}>
                        <FormField
                          // icon="mdi mdi-bank"
                          id="website"
                          // maxlength='40'
                          value={websiteURL ? websiteURL : "https://www."}
                          onChange={(e) => setWebsiteURL(e.target.value)}
                          placeholder="E.g. https://readyteacher.com.au"
                          autoFocus
                          onBlur={handleEditWebsiteURL}
                          // onKeyUp={handleTaglineUpdateByKey}
                          className="tagline-textbox"
                        />
                      </form>
                    ) : (
                      <h2 className="h-secondary">
                        {institution.website_url ? (
                            updateWebsiteURL && isAbleToEdit ? (
                          <a
                            href={institution.website_url}
                            target="_blank"
                            title="Visit Website"
                          >
                            <Icon
                              name="share square"
                              // circular
                              // inverted
                              size="large"
                              color="teal"
                              className="qualification-container-update-icon"
                            />
                            {/* {institution.website_url} */}
                          </a>
                            ): null) : isAbleToEdit ? (
                          <em>Enter your website URL</em>
                        ) : (
                          ""
                        )}{" "}
                        {updateWebsiteURL && isAbleToEdit ? (
                          <>
                            <Icon
                              name="pencil"
                              circular
                              inverted
                              color="teal"
                              className="qualification-container-update-icon"
                              onClick={() => setEditWebsite(true)}
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </h2>
                    )}
                  </div>
                </div>

                {/* <h2 className='h-secondary'></h2> */}
                {/* the Tagline for institution information */}
                <div className="tag-line">
                  <div className="tagline-entry">
                    {viewEditTagline ? (
                      <form onSubmit={handleEditTagline}>
                        <FormField
                          // icon="mdi mdi-bank"
                          id="tagLine"
                          maxlength="40"
                          value={tagline}
                          onChange={(e) => setTagline(e.target.value)}
                          placeholder="E.g.: A premium institution in the heart of town."
                          autoFocus
                          onBlur={handleEditTagline}
                          // onKeyUp={handleTaglineUpdateByKey}
                          className="tagline-textbox"
                        />
                      </form>
                    ) : (
                      <h2 className="h-secondary">
                        {institution.tagline ? (
                          institution.tagline
                        ) : isAbleToEdit ? (
                          <em>Enter your tagline</em>
                        ) : (
                          ""
                        )}{" "}
                        {updateTagline && isAbleToEdit ? (
                          <Icon
                            name="pencil"
                            circular
                            inverted
                            color="teal"
                            className="qualification-container-update-icon"
                            onClick={() => setEditTagline(true)}
                          />
                        ) : (
                          ""
                        )}
                      </h2>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-10">
                {!isShared && showShareButton && (
                <button
                    className="home-share-button"
                    // title="Share Profile"
                    onClick={showShareProfile}
                >
                <a className="mdi mdi-share" data-tip="Share Profile" data-for="share profile">
                </a>
                <ReactTooltip backgroundColor="rgb(47, 224, 222)" id="share profile" effect="solid" place="right" />
                </button>
          )}
          </div>
            {/* {displayWhereby} */}
          </div>
          {/* {displayPoliceCheckWwCC} */}
        </div>
        {isSeparateTabsWithLogo && (
          <div className="home-container-lg-spacing" />
        )}
        <div className="page-container-inner">
          {tabs ? <Tabs tabs={tabs} /> : null}
          {isSkipInnerSpacing ? (
            <Fragment>{props.children}</Fragment>
          ) : (
            <div className={removeTopMargin ? "" : "home-container-spacing"}>
              {props.children}
            </div>
          )}
        </div>
      </div>
      {isPopup && (
        <PopUp
          institution={institution}
          showPopup={togglePopup}
          formType={formType}
          isShared={isShared}
        />
      )}
      {/* <StickyButton/> */}
    </div>
  );
}

export default withRouter(CollegeHomeContainer);
